export const eventList = [
    {
      name: "Drift & Slide",
      description:
        "A day-long event where drivers compete in drifting and sliding competitions, showcasing their car control skills and high-performance vehicles.",
      image: require("../../assets/images/event1.jpg"),
      date: {
        day: "21",
        month: "Jul",
      },
    },
    {
      name: "Race for a Cause",
      description:
        "A rally event to raise money for a local charity, with participants driving modified vehicles on a scenic route, raising awareness and funds for a good cause.",
      image: require("../../assets/images/event2.jpg"),
  
      date: {
        day: "9",
        month: "Aug",
      },
    },
    {
      name: "Scenic Convoy",
      description:
        "A convoy event where participants drive a procession of vehicles on a scenic route, showcasing modified vehicles and enjoying a scenic drive together.",
      image: require("../../assets/images/event3.jpg"),
  
      date: {
        day: "27",
        month: "Aug",
      },
    },
    {
      name: "Cruise Night",
      description:
        "A night-time event where drivers can show off their modified vehicles and cruise together, with music, food, and a display of some of the area's best cars.",
      image: require("../../assets/images/event4.jpg"),
  
      date: {
        day: "4",
        month: "Sep",
      },
    },
  ];
  